import React, { Component } from "react";
import classNames from "classnames";
import { FormField } from "react-form";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import { withStyles, Typography } from "@material-ui/core";
import FormLabel from "@material-ui/core/FormLabel";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";

const styles = (theme) => ({
    root: {
        display: "flex",
        color: "#c62828",
    },
    label: {
        color: "#c62828",
    },
    group: {
        margin: "0",
    },
    fullWidth: {
        width: "100%",
    },
    horizontal: {
        margin: "0",
        display: "inline",
    },
    groupName: {
        color: "#212529",
    },
    height: {
        marginTop: -8,
        marginBottom: -4,
    },
    nowrap: {
        //whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        "& label": {
            color: "#c62828",
        },
    },
    error: {
        "& h3": {
            // No way to access actual text - probably because typography tag is being passed as label
            color: "#be0000",
        },
        "& svg": {
            color: "rgba(0, 0, 0, 0.87)",
        },
    },
    radioOption: {
        display: "inline-flex",
        alignItems: "center",
        marginRight: 16,
        cursor: "pointer",
        borderRadius: 4,
        padding: "2px 6px",
        outline: "none",

        "&:focus": {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: 2,
        },

        "&:focus-visible": {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: 2,
        },
    },

    radioOptionDisabled: {
        cursor: "not-allowed",
        opacity: 0.6,
    },
});

class AccessabilityRadioGroupWrapper extends Component {
    constructor(props) {
        super(props);
        this._instanceId = Math.random().toString(36).slice(2);
    }

    setRadioValue = (raw) => {
        const { fieldApi, eventHandle, name } = this.props;
        const { setValue, setTouched } = fieldApi;

        let next = raw;
        if (next === "true") next = true;
        if (next === "false") next = false;

        setValue(next);
        setTouched();
        if (eventHandle) eventHandle(next, name);
    };

    handleChange = (event) => {
        this.setRadioValue(event.target.value);
    };

    render() {
        const {
            fieldApi,
            label,
            children,
            options,
            classes,
            required,
            alignment,
            fullWidth,
            style,
            disabled,
            labelTitle,
            optionTitle = false,
            ...rest
        } = this.props;

        const { getValue, getError } = fieldApi;

        let value = getValue();
        const error = getError();
        const hasError = !!error;

        if (value === true) value = "true";
        if (value === false) value = "false";

        const raw = rest.name || (typeof label === "string" ? label : "") || "group";
        const safe = String(raw).trim().replace(/[^A-Za-z0-9\-_:.]/g, "-");
        const labelId = `radiogroup-${safe}-${this._instanceId}-label`;
        const groupName = `radiogroup-${safe}-${this._instanceId}`;

        return (
            <div>
                <FormControl
                    component="fieldset"
                    style={style}
                    error={!!error}
                    className={classNames(fullWidth && classes.fullWidth)}
                >
                    <FormLabel id={labelId} component="legend" required={required}>
                        <Typography title={labelTitle || null} className={classes.nowrap} style={{ marginTop: -4 }}>
                            {label || children}
                        </Typography>
                    </FormLabel>

                    <div
                        role="radiogroup"
                        aria-labelledby={labelId}
                        style={{ display: alignment ? "inline-flex" : "block" }}
                    >
                        {options.map((object, idx) => {
                            const checked = String(value ?? "") === String(object.value);
                            const optionId = `${labelId}-opt-${idx}`;

                            return (
                                <div
                                    key={`${labelId}-${String(object.value)}`}
                                    role="radio"
                                    aria-checked={checked}
                                    aria-labelledby={optionId}
                                    tabIndex={disabled || object.disabled ? -1 : 0}
                                    onClick={() => this.setRadioValue(object.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            this.setRadioValue(object.value);
                                        }
                                        if (e.key === "ArrowRight" || e.key === "ArrowDown") {
                                            e.preventDefault();
                                            const next = options[(idx + 1) % options.length];
                                            this.setRadioValue(next.value);
                                        }
                                        if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
                                            e.preventDefault();
                                            const prev = options[(idx - 1 + options.length) % options.length];
                                            this.setRadioValue(prev.value);
                                        }
                                    }}
                                    className={classNames(
                                        classes.radioOption,
                                        (disabled || object.disabled) && classes.radioOptionDisabled
                                    )}
                                >
                                    <span aria-hidden="true" style={{ display: "inline-flex", marginRight: 6 }}>
                                        {checked ? (
                                            <RadioButtonCheckedIcon style={{ color: object.color }} />
                                        ) : (
                                            <RadioButtonUncheckedIcon style={{ color: object.color }} />
                                        )}
                                    </span>

                                    <span id={optionId}>{object.label}</span>
                                </div>
                            );
                        })}
                    </div>

                    {error && <FormHelperText style={{ marginTop: 0, color: "#c62828" }}>{error}</FormHelperText>}
                    {required && !hasError && <FormHelperText style={{ marginTop: -1 }}>Required</FormHelperText>}
                </FormControl>
            </div>
        );
    }
}

AccessabilityRadioGroupWrapper.displayName = "AccessabilityRadioGroupWrapper";
const AccFppRadioGroup = FormField(AccessabilityRadioGroupWrapper);

export default withStyles(styles)(AccFppRadioGroup);
